import { render, staticRenderFns } from "./LanguageModel.vue?vue&type=template&id=ca8b5256"
import script from "./LanguageModel.vue?vue&type=script&lang=js"
export * from "./LanguageModel.vue?vue&type=script&lang=js"
import style0 from "./LanguageModel.vue?vue&type=style&index=0&id=ca8b5256&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports